/** Réparation de l'application et détection des boucles de plantage au démarrage. */

const BOOT_KEY = 'terminal.nsi:boots';
const DISPLAY_KEYS = ['terminal.nsi:theme', 'terminal.nsi:fontSize'];
const CRASH_WINDOW_MS = 60_000;
const CRASH_THRESHOLD = 3;

export function recordBootAttempt(): void {
  try {
    const now = Date.now();
    const raw = sessionStorage.getItem(BOOT_KEY);
    const previous: number[] = raw ? (JSON.parse(raw) as number[]) : [];
    const recent = previous.filter((time) => now - time < CRASH_WINDOW_MS);
    recent.push(now);
    sessionStorage.setItem(BOOT_KEY, JSON.stringify(recent));
  } catch {
    /* sessionStorage indisponible */
  }
}

export function isCrashLoop(): boolean {
  try {
    const raw = sessionStorage.getItem(BOOT_KEY);
    const previous: number[] = raw ? (JSON.parse(raw) as number[]) : [];
    return previous.filter((time) => Date.now() - time < CRASH_WINDOW_MS).length >= CRASH_THRESHOLD;
  } catch {
    return false;
  }
}

export function clearBootAttempts(): void {
  try {
    sessionStorage.removeItem(BOOT_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Réparation sans mot de passe : vide les caches, le service worker et les
 * préférences d'affichage, puis recharge. **Ne touche à aucun compte.**
 */
export function repairApplication(): void {
  for (const key of DISPLAY_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }
  clearBootAttempts();
  void (async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    } finally {
      window.location.reload();
    }
  })();
}
